import "./VisitUs.module.css";
import Header from "@/reusable_sections/Header";
import FindYourWay from "./sections/FindYourWay";
import SayHello from "./sections/SayHello";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function VisitUsPage() {
  return <div>
      <Header />
      <FindYourWay />
      <SayHello />
      <CommonQuestions />
      <Footer />
    </div>;
}